import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { getBaseUrl, STREAMS_ENDPOINT } from '../../constants';

import { normalizeStream, normalizeStreams, toStreamPayload } from '../normalizers';

export class Streams {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Streams(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = STREAMS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllStream(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: normalizeStreams(response?.data), meta: response?.meta };
  }

  async getStreamById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.getData(url);
    return normalizeStream(response?.data);
  }

  async putStreamById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.putData(url, toStreamPayload(req.reqBody));
    return normalizeStream(response?.data);
  }

  async postStream(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, toStreamPayload(reqBody));
    return normalizeStream(response?.data);
  }

  async deleteStreamById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, toStreamPayload(req.reqBody));
    return response;
  }
}

export const createStreams = () => Streams.getInstance();
